module.exports = __webpack_public_path__ + "img/haidayuan.94d9fdd8.svg";